// @flow
import _ from 'lodash';

import type { TDraftLeaguesReducer } from '../../types';

export const getWaiversList = (
	state: TDraftLeaguesReducer
) => _.get(state, 'leagues.waiver_list.by_id', {});

export default getWaiversList;